import { render, staticRenderFns } from "./VoucherByPurposes.vue?vue&type=template&id=07a94c37&"
import script from "./VoucherByPurposes.vue?vue&type=script&lang=js&"
export * from "./VoucherByPurposes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports